
const Error = (props: {message: string | React.ReactNode}) => {
    return (<div>{props.message}</div>)
}
export default Error;
